module.exports = __webpack_public_path__ + "static/unicorn-0748fa4d994b75707ab4e97f49a790a6.jpg";